import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/Store/store";
import { toast } from "react-toastify";
import httpRequest from "src/helpers/httpRequest";
import {
  calcualteTotalPrice,
  ICustomJwtPayload,
  isProfileCompleted,
} from "src/helpers/helperFunctions";
import { loadStripe } from "@stripe/stripe-js";
import { Skeleton } from "@mui/material";
import DrawerTitle from "../Drawer/DrawerTitle";
import TabsButton from "./TabsButton";
import CustomRadio from "../GlobalComponents/CustomRadio";
import CounterComponent from "../Customer/ProductsAndServicesComponents/CounterComponent";
import GradientBtn from "src/Components/WebsiteComponents/GradientBtn";
import OrderDetailsBox from "./ManageCart/OrderDetailsBox";
import ManageCheckout from "./ManageCart/ManageCheckout";
import RenderText from "../Text/RenderText";
import DiagnosticProductImg from "src/assets/images/diagnostric-product-img.png";
import TestIcon from "src/assets/images/website-images/test-icon.png";
import BloodIcon from "src/assets/images/website-images/blood-icon.png";
import NoItemPharmacyImg from "src/assets/images/not-data/no-cart.png";
import {
  AllTabType,
  IDiagnosticCartItem,
  IPharmacyCartItem,
} from "src/types/GlobalInterfaces";
import {
  CURRENCY,
  EXPRESS_DELIVERY_CHARGE,
  STANDARD_DELIVERY_CHARGE,
} from "src/lib/constans";

import DileveryAddressTitle from "../GlobalComponents/DileveryAddressTitle";
import LoginCustomer from "./LoginCustomer";
import ManageAddressScreen from "./ManageAddressScreen";
import NoItemUI from "../NoItemUI";
import TabsSlideContainer from "../GlobalComponents/Widget/TabsSlideContainer";
import PaymentMethodComponents from "../GlobalComponents/PaymentMethodComponents";
import EditProfileScreen from "./EditProfileScreen";

interface IProps {
  onBack: () => void;
  setActiveTab: (tab: AllTabType) => void;
  isOpen: boolean;
}

interface ICartData {
  pharmacyLoader: boolean;
  pharmacyProducts: IPharmacyCartItem[];
  diagnosticLoader: boolean;
  diagnosticProducts: IDiagnosticCartItem[];
}

interface IPayload {
  totalAmount: number;
  diagnosticPrescription: any[];
}

const BoxIcon = ({
  icon,
  title,
  skeleton,
}: {
  icon?: string;
  title: string;
  skeleton?: boolean;
}) => {
  return (
    <div className="flex gap-1 items-center">
      {skeleton ? (
        <>
          <Skeleton
            variant="rectangular"
            width={15}
            height={15}
            sx={{ borderRadius: "4px" }}
          />
          <Skeleton variant="text" width={50} height={12} />
        </>
      ) : (
        <>
          <div className="w-[15px] h-[15px] border border-gray-400 rounded flex items-center justify-center">
            <img
              src={icon}
              alt="icon"
              className="max-w-[80%] max-h-[80%] object-contain"
            />
          </div>
          <RenderText className="font-Poppins-Regular font-size-12px text-[#333333]">
            {title}
          </RenderText>
        </>
      )}
    </div>
  );
};

const RenderPharmacyOrderProduct = ({
  product,
  removeCartItem,
  changeQuantity,
  isSelected,
  toggleSelection,
  radioId,
  counterId,
}: {
  product: IPharmacyCartItem;
  removeCartItem: (id: string, category: string) => void;
  changeQuantity: (val: number, id: string) => void;
  isSelected: boolean;
  toggleSelection: (id: string) => void;
  radioId: string;
  counterId: string;
}) => {
  return (
    <div className="flex items-start 2xl:gap-2 gap-1 border-b relative border-gray-300 pb-4">
      <div className="flex items-center gap-0.5 2xl:gap-1">
        <CustomRadio
          checked={isSelected}
          onClick={(e) => {
            e.stopPropagation();
            toggleSelection(product._id);
            console.log(product._id, "product._id");
          }}
          id={radioId || "pharmacy-product-radio"}
        />
        <div className="w-[50px] lg:w-[100px] max-w-[50px] lg:max-w-[5.3vw] overflow-hidden aspect-square border border-gray-300 rounded-sm lg:rounded-md flex items-center justify-center">
          <img
            src={product.image ? product.image : DiagnosticProductImg}
            alt="product"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
      <div className="flex-1 flex flex-col 2xl:gap-2 gap-0.5 justify-between">
        <p className="font-Poppins-Regular font-size-16px line-clamp-2 text-[#3B3B3B] leading-snug break-words whitespace-normal w-full">
          {product?.productName || "Product Name"}
        </p>
        <div className="flex items-center gap-2">
          <span className="text-[#202020] font-Poppins-SemiBold font-size-20px">
            {CURRENCY}{" "}
            {Number(product.salePrice || product.regularPrice || 0).toFixed(2)}
          </span>
          {product?.regularPrice && product?.salePrice && (
            <span className="text-[#434343] line-through font-Poppins-Regular font-size-15px">
              {CURRENCY} {Number(product.regularPrice).toFixed(2)}
            </span>
          )}
        </div>
        <div className="absolute right-0 bottom-2">
          <CounterComponent
            productId={product._id}
            type="pharmacy"
            updateCount={(val: number) => changeQuantity(val, product._id)}
            bgColor
            handleRemove={(id: string) =>
              removeCartItem(id, "pharmacyProducts")
            }
            stockQuantity={product?.quantity}
            id={counterId || "pharmacy-product-counter"}
          />
        </div>
      </div>
    </div>
  );
};

const RenderLabTestOrderProduct = ({
  product,
  removeCartItem,
  isSelected,
  toggleSelection,
  radioId,
  counterId,
}: {
  product: IDiagnosticCartItem;
  removeCartItem: (id: string, category: string) => void;
  isSelected: boolean;
  toggleSelection: (id: string) => void;
  radioId: string;
  counterId: string;
}) => {
  return (
    <div className="flex items-start 2xl:gap-2 gap-1 border-b relative border-gray-300 pb-4">
      <div className="flex items-center gap-0.5 2xl:gap-1">
        <CustomRadio
          checked={isSelected}
          onClick={(e) => {
            e.stopPropagation();
            toggleSelection(product._id);
          }}
          id={radioId || "diagnostic-product-radio"}
        />
        <div className="w-[50px] lg:w-[100px] max-w-[50px] lg:max-w-[5vw] overflow-hidden aspect-[1/1] border border-gray-300 rounded-sm lg:rounded-md flex items-center justify-center">
          <img
            src={product.image ? product.image : DiagnosticProductImg}
            alt="product"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="flex-1 flex flex-col 2xl:gap-2 gap-1 justify-between">
        <p className="font-Montserrat-SemiBold line-clamp-1 font-size-20px text-[#3B3B3B] leading-snug break-words whitespace-normal w-full">
          {product.name || "Lab Test"}
        </p>
        <div className="flex items-center gap-2">
          <BoxIcon
            icon={TestIcon}
            title={`${product.noOfBiomarkers || product.noOfTests} ${
              product.cartItemType === "product"
                ? `${product.noOfBiomarkers > 1 ? "Biomarkers" : "Biomarker"}`
                : `${product.noOfTests > 1 ? "Tests" : "Test"}`
            }`}
          />
          <BoxIcon icon={BloodIcon} title={product.testType ? product.testType : "Blood Sample"} />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[#202020] font-Poppins-SemiBold font-size-20px">
            {CURRENCY}{" "}
            {Number(product.salePrice || product.regularPrice || 0).toFixed(2)}
          </span>
          {product?.regularPrice && product?.salePrice && (
            <span className="text-[#434343] line-through font-Poppins-Regular font-size-15px">
              {CURRENCY} {Number(product.regularPrice).toFixed(2)}
            </span>
          )}
        </div>
        <div className="absolute right-0 bottom-2">
          <CounterComponent
            productId={product._id}
            type="diagnostic"
            updateCount={() => {}}
            bgColor
            handleRemove={(id: string) =>
              removeCartItem(id, "diagnosticProducts")
            }
            onlyRemove
            stockQuantity={product?.quantity}
            id={counterId || "diagnostic-product-counter"}
          />
        </div>
      </div>
    </div>
  );
};

interface IProps {
  onBack: () => void;
  isOpen: boolean;
  setActiveTab: (tab: AllTabType) => void;
  onSuccess: () => void;
}

const ManageCartScreen: React.FC<IProps> = ({
  onBack,
  isOpen,
  setActiveTab,
  onSuccess,
}: IProps) => {
  const { isLogged, userDetails } = useSelector(
    (state: RootState) => state.appReducer
  );
  const { pharmacyProducts, diagnosticProducts } = useSelector(
    (state: RootState) => state.cartSlice
  );
  const { cartItems } = useSelector((state: RootState) => state.cart);
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const [acTab, setAcTab] = useState<string>("pharmacy");

  const [checkout, setCheckout] = useState<boolean>(false);

  const [data, setData] = useState<ICartData>({
    pharmacyLoader: false,
    pharmacyProducts: [],
    diagnosticLoader: false,
    diagnosticProducts: [],
  });
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [paymentMethodId, setPaymentMethodId] = useState<string>("");
  // CHECK OUT COMPONENT STATES
  const [deliveryInstructions, setDeliveryInstructions] = useState<
    | "avoid ringing"
    | "leave at the door"
    | "avoid calling"
    | "leave with the security"
  >("avoid calling");
  const [deliveryType, setDeliveryType] = useState<
    "instant delivery" | "express delivery"
  >("express delivery");
  const [payload, setPayload] = useState<IPayload>({
    totalAmount: 0,
    diagnosticPrescription: [],
  });
  const [isAddressModalOpen, setIsAddressModalOpen] = useState<boolean>(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState<boolean>(false);
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [minHeight, setMinHeight] = useState<number>(0);
  const tabs = [
    {
      name: "Pharmacy",
      value: "pharmacy",
      count: isLogged
        ? cartItems.filter((v: any) => v.type === "pharmacy")?.length
        : pharmacyProducts?.length,
    },
    {
      name: "Lab Tests",
      value: "diagnostic",
      count: isLogged
        ? cartItems.filter((v: any) => v.type !== "pharmacy")?.length
        : diagnosticProducts?.length,
    },
  ];

  const toggleSelection = (productId: string) => {
    console.log(selectedProductIds, "selectedProductIds");
    console.log(productId, "productId");
    let find = selectedProductIds.find((id) => id === productId);
    if (find) {
      setSelectedProductIds((prev) => prev.filter((id) => id !== productId));
    } else {
      setSelectedProductIds((prev) => [...prev, productId]);
    }
  };

  const removeCartItem = (
    id: string,
    category: "pharmacyProducts" | "diagnosticProducts"
  ) => {
    setData((prev) => ({
      ...prev,
      [category]: (prev[category] as any)?.filter(
        (v: { _id: string; [key: string]: any }) => v._id !== id
      ),
    }));
    setSelectedProductIds((prev) => prev.filter((pid) => pid !== id));
  };

  const changeQuantity = (val: number, id: string) => {
    setData((prev) => ({
      ...prev,
      pharmacyProducts: prev.pharmacyProducts.map((v) =>
        v._id === id ? { ...v, selectedQuantity: val } : v
      ),
    }));
  };

  const fetchPharmacyProducts = async () => {
    if (isLogged) {
      if (!cartItems?.filter((v: any) => v.type === "pharmacy")?.length) return;
    } else {
      if (!pharmacyProducts?.length) return;
    }
    setData((prev) => ({ ...prev, pharmacyLoader: true }));
    const { res, err } = await httpRequest<IPharmacyCartItem[]>({
      method: "post",
      path: "/pharma-inventory/get/products-by-ids",
      params: {
        ids: isLogged
          ? cartItems
              .filter((v: any) => v.type === "pharmacy")
              .map((v: any) => v.productId)
          : pharmacyProducts.map((v) => v._id),
      },
    });
    if (res) {
      setData((prev) => ({
        ...prev,
        pharmacyLoader: false,
        pharmacyProducts: res.map((v) => ({
          ...v,
          selectedQuantity:
          isLogged ?
            cartItems.find((q) => q.productId === v._id)?.quantity || 1
            : pharmacyProducts.find((q) => q._id === v._id)?.quantity || 1,
        })),
      }));
      setSelectedProductIds(res.map((v) => v._id));
    } else {
      toast(err, { type: "error" });
    }
    setData((prev) => ({ ...prev, pharmacyLoader: false }));
  };

  const fetchDiagnosticProducts = async () => {
    if (isLogged) {
      if (!cartItems?.filter((v: any) => v.type !== "pharmacy")?.length) return;
    } else {
      if (!diagnosticProducts?.length) return;
    }
    setData((prev) => ({ ...prev, diagnosticLoader: true }));
    const { res, err } = await httpRequest<IDiagnosticCartItem[]>({
      method: "post",
      path: "/product/cart-items",
      params: {
        ids: isLogged
          ? cartItems
              .filter((v: any) => v.type !== "pharmacy")
              .map((v: any) => v.productId)
          : diagnosticProducts.map((v) => v._id),
      },
    });
    if (res) {
      setData((prev) => ({
        ...prev,
        diagnosticLoader: false,
        diagnosticProducts: res,
      }));
      setSelectedProductIds(res.map((v) => v._id));
    } else {
      toast(err, { type: "error" });
    }
    setData((prev) => ({ ...prev, diagnosticLoader: false }));
  };

  const BeforeValidation = async () => {
    if (!selectedProductIds.length) {
      toast("Please select at least one product to proceed.", {
        type: "error",
      });
      return false;
    }

    const { res, err: validateErr } = await httpRequest({
      method: "post",
      path:
        acTab === "pharmacy"
          ? "/pharma-order/validate"
          : "/diagnostic-order/validate",
      params: {
        totalAmount: totalPrice,
        items: selectedProductIds?.map((v: string) => {
          const product =
            acTab === "pharmacy"
              ? data.pharmacyProducts.find(
                  (p: IPharmacyCartItem) => p._id === v
                )
              : data.diagnosticProducts.find(
                  (p: IDiagnosticCartItem) => p._id === v
                );
          if (!product) return null;

          return acTab === "pharmacy"
            ? {
                productId: product?._id,
                quantity: product?.selectedQuantity,
                productPrice: product?.salePrice || product?.regularPrice,
              }
            : {
                productId: product?._id,
                itemType: (product as IDiagnosticCartItem)?.cartItemType,
              };
        }),
      },
    });

    if (validateErr) {
      toast(validateErr || "Order validation failed.", { type: "error" });
      return false;
    }
    return true;
  };

  const handleCardPayment = async (data: { paymentIndentId: string }) => {
    console.log(data, "data");
    setPaymentMethodId(data.paymentIndentId);
    setCheckout(true);
  };

  useEffect(() => {
    setSelectedProductIds([]);
    setDeliveryType("express delivery");
    if (acTab === "pharmacy") {
      fetchPharmacyProducts();
    } else if (acTab === "diagnostic") {
      fetchDiagnosticProducts();
    }
  }, [acTab, isOpen]);

  useEffect(() => {
    let selectedProducts: IPharmacyCartItem[] | IDiagnosticCartItem[] = [];
    if (acTab === "pharmacy") {
      selectedProducts = data.pharmacyProducts.filter((p: IPharmacyCartItem) =>
        selectedProductIds.includes(p._id)
      );
    } else {
      selectedProducts = data.diagnosticProducts.filter(
        (p: IDiagnosticCartItem) => selectedProductIds.includes(p._id)
      );
    }

    if (selectedProducts.length) {
      const total = calcualteTotalPrice(
        selectedProducts.map((v) => ({
          salePrice: Number(v.salePrice) || 0,
          regularPrice: Number(v.regularPrice) || 0,
          quantity:
            acTab === "pharmacy"
              ? (v as IPharmacyCartItem).selectedQuantity || 1
              : 1,
        }))
      );
      setTotalPrice(total);
    } else {
      setTotalPrice(0);
    }
  }, [
    data.pharmacyProducts,
    data.diagnosticProducts,
    acTab,
    selectedProductIds,
  ]);

  useEffect(() => {
      let ele : any = document.querySelector(".tab-slider-container-main");
      if (ele) {
        let height = ele?.clientHeight;
        let top = ele.offsetTop;
        let minHeight = window.innerHeight - top - height - 120;
        setMinHeight(minHeight);
      }else{
        setMinHeight(100);
      }
  }, [acTab]);

  return (
    <>
      {isLogin && !isAddressModalOpen && (
        <LoginCustomer
          onBack={() => {
            setIsLogin(false);
          }}
          onSuccess={() => {
            setIsLogin(false);
            setTimeout(() => {
              let btn = document.getElementById("checkout-btn");
              if (btn) {
                btn.click();
              }
              setIsClicked(false);
            }, 500);
          }}
          backBtn
        />
      )}
      {isProfileModalOpen && !isLogin && !isAddressModalOpen && (
        <EditProfileScreen
          onBack={() => {
            setIsProfileModalOpen(false);
          }}
          onSuccess={() => {
            setIsProfileModalOpen(false);
          }}
          forceBack
        />
      )}
      {isAddressModalOpen && !isLogin && (
        <ManageAddressScreen
          onBack={() => {
            setIsAddressModalOpen(false);
            setTimeout(() => {
              if (isClicked) {
                let btn = document.getElementById("checkout-btn");
                if (btn) {
                  btn.click();
                }
                setIsClicked(false);
              }
            }, 500);
          }}
          directBack={true}
        />
      )}
      <div
        className={`w-full ${
          checkout || isAddressModalOpen || isLogin || isProfileModalOpen
            ? "hidden"
            : ""
        }`}
      >
        {!isLogin && !isAddressModalOpen && !isProfileModalOpen && (
          <DrawerTitle title="Cart" onBack={onBack} backBtn />
        )}
        <div className="flex flex-col 2xl:p-4 p-2.5 2xl:gap-4 gap-2 bg-white">
          <div className="w-full flex bg-[#FFFFFF] flex-col gap-2 2xl:gap-4">
            <div className="flex gap-2 overflow-x-auto overflow-y-hidden scroll-hide">
              <TabsSlideContainer
                tabs={tabs}
                activeTab={tabs.find((tab) => tab.value === acTab) || tabs[0]}
                onChange={(tab) => setAcTab(tab?.value || "")}
                showCount
              />
            </div>
          </div>
          {(
            acTab === "pharmacy"
              ? isLogged
                ? cartItems?.filter((v: any) => v.type === "pharmacy")
                    ?.length !== 0
                : pharmacyProducts?.length !== 0
              : isLogged
              ? cartItems?.filter((v: any) => v.type !== "pharmacy")?.length !==
                0
              : diagnosticProducts?.length !== 0
          ) ? (
            <>
              <DileveryAddressTitle
                onAddressClick={() => {
                  setIsClicked(false);
                  setIsAddressModalOpen(true);
                }}
              />
              <div className="flex flex-col bg-[#FFFFFF] 2xl:gap-4 gap-2">
                {acTab === "pharmacy" ? (
                  data.pharmacyLoader ? (
                    [1, 2, 3].map((_, index) => (
                      <Skeleton
                        key={index}
                        variant="rectangular"
                        height={120}
                      />
                    ))
                  ) : data.pharmacyProducts.length ? (
                    data.pharmacyProducts.map((product, index) => (
                      <RenderPharmacyOrderProduct
                        key={product._id + index}
                        product={product}
                        removeCartItem={() =>
                          removeCartItem(product._id, "pharmacyProducts")
                        }
                        changeQuantity={changeQuantity}
                        isSelected={selectedProductIds.includes(product._id)}
                        toggleSelection={toggleSelection}
                        radioId={`pharmacy-product-${index}`}
                        counterId={`pharmacy-product-counter-${index}`}
                      />
                    ))
                  ) : (
                    <p className="text-center font-size-16px font-Poppins-Regular text-[#3B3B3B]">
                      No pharmacy products in cart.
                    </p>
                  )
                ) : data.diagnosticLoader ? (
                  [1, 2, 3].map((_, index) => (
                    <Skeleton key={index} variant="rectangular" height={120} />
                  ))
                ) : data.diagnosticProducts.length ? (
                  data.diagnosticProducts.map((product, index) => (
                    <RenderLabTestOrderProduct
                      key={product._id + index}
                      product={product}
                      removeCartItem={() =>
                        removeCartItem(product._id, "diagnosticProducts")
                      }
                      isSelected={selectedProductIds.includes(product._id)}
                      toggleSelection={toggleSelection}
                      radioId={`diagnostic-product-${index}`}
                      counterId={`diagnostic-product-counter-${index}`}
                    />
                  ))
                ) : (
                  <p className="text-center font-size-16px font-Poppins-Regular text-[#3B3B3B]">
                    No lab tests in cart.
                  </p>
                )}
              </div>
              <PaymentMethodComponents
                profileValidation={acTab === "diagnostic" ? true : false}
                cardPaymentConfig={{
                  validation: {
                    beforeSubmit: BeforeValidation,
                  },
                  onSuccess: handleCardPayment,
                  onError: (error: { type: string; message: string }) => {
                    if (error.type === "login") {
                      setIsLogin(true);
                      return;
                    }

                    if (error.type === "address") {
                      setIsAddressModalOpen(true);
                      return;
                    }
                    if (error.type === "profile") {
                      setIsProfileModalOpen(true);
                      return;
                    }
                  },
                }}
                customFormFooter={({ isLoader }: { isLoader: boolean }) => {
                  return (
                    <>
                      <div className="absolute bottom-0 left-0 w-full bg-white shadow-[0px_-1px_12px_#00000029] 2xl:p-3 p-2 2xl:h-[60px] h-[50px] flex items-center gap-3">
                        <p className="font-size-18px font-Poppins-SemiBold text-[#2F2F31]">
                          {CURRENCY}: {totalPrice.toFixed(2)}
                        </p>
                        <div className="flex-1">
                          <GradientBtn
                            ButtonText={
                              isLogged
                                ? (
                                    acTab === "pharmacy"
                                      ? true
                                      : isProfileCompleted(
                                          userDetails as ICustomJwtPayload
                                        )
                                  )
                                  ? "Checkout"
                                  : "Complete Profile to Checkout"
                                : "Login to Checkout"
                            }
                            loader={isLoader}
                            type="submit"
                            btnExtraStyle={{ width: "100%" }}
                            id="checkout-btn"
                          />
                        </div>
                      </div>
                    </>
                  );
                }}
              />
              <OrderDetailsBox
                orderTotal={totalPrice}
                shipping={
                  deliveryType === "instant delivery"
                    ? EXPRESS_DELIVERY_CHARGE
                    : STANDARD_DELIVERY_CHARGE
                }
                isPharma={acTab === "pharmacy" ? true : false}
              />
              <div className="h-[50px]"></div>
            </>
          ) : (
            <div className="w-full mt-5">
              <NoItemUI
                minHeight={minHeight}
                text="Your Cart Is Empty"
                text2="Check Out What's Trending"
                iconImagePath={NoItemPharmacyImg}
                onButtonClick={() => {
                  onBack();
                  navigate(
                    acTab === "pharmacy" ? "/category" : "/diagnostic-products"
                  );
                }}
                ButtonText={
                  acTab === "pharmacy"
                    ? "Discover Products"
                    : "Discover Lab Tests"
                }
              />
            </div>
          )}
        </div>
      </div>
      <ManageCheckout
        show={checkout}
        onBack={() => setCheckout(false)}
        setCheckout={setCheckout}
        deliveryType={deliveryType}
        setDeliveryType={setDeliveryType}
        orderData={{
          products:
            acTab === "pharmacy"
              ? data.pharmacyProducts.filter((p) =>
                  selectedProductIds.includes(p._id)
                )
              : data.diagnosticProducts.filter((p) =>
                  selectedProductIds.includes(p._id)
                ),
          totalPrice,
          paymentMethodId: paymentMethodId || "",
          selectedProductIds,
        }}
        acTab={acTab as "pharmacy" | "diagnostic"}
        confirmOrder={() => {
          onSuccess?.();
          setCheckout(false);
        }}
        deliveryInstructions={deliveryInstructions}
        setDeliveryInstructions={setDeliveryInstructions}
        onError={() => {
          setCheckout(false);
        }}
      />
    </>
  );
};

export default ManageCartScreen;
